exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Layout[data-v-e76b2b8c]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;width:100%;height:100%}.Layout__Content[data-v-e76b2b8c]{margin:0;padding:30px;background-color:#f8f9fa;height:100%}", ""]);
